import { noop } from '@kofno/piper';
import { Task } from 'taskarian';
import { Error } from '../ErrorHandling';

//Arguments are taken directly from History.pushState
export const pushState = (data: any, title: string, url?: string | null): Task<Error, void> =>
  new Task<Error, void>((reject, resolve) => {
    try {
      window.history.pushState(data, title, url);
      resolve();
    } catch (e) {
      reject({
        kind: 'error',
        message: 'An error occurred, please refresh the page and try again',
      });
    }
    return noop;
  });
